import React, {useCallback, useEffect} from 'react'
import {useAppSelector} from '@/hooks/redux'
import {selectLoad} from '@/store/selectors'
import Loader from '@/components/Loader'
import UserService from '@/services/api/User'

const LoaderProvider = () => {
  const isLoad = useAppSelector(selectLoad)

  const checkWork = useCallback(async () => {
    try {
      const response = await UserService.checkWork()
      if (response.status === 200) {
        if (response.data.status) {
          if (window.location.pathname !== '/maintenance') {
            window.location.href = '/maintenance'
          }
        }
      }
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to check work status:', e)
      }
    }
  }, [])

  useEffect(() => {
    void checkWork()
    // const interval = setInterval(() => {
    //   void checkWork()
    // }, 60000)

    //
    // return () => {
    //   clearInterval(interval)
    // }
  }, [])

  return <Loader isLoad={isLoad} />
}

export default LoaderProvider
